const DATA_TEST_IDS = {
  pinCodeExpiredFragment: 'authentication__common_pin-code-expired-fragment',
} as const;

export default DATA_TEST_IDS;
